import {SmdDataRowModel} from '../../../../shared/component/smd-datatable/datatable-row.component';

export class MultivalueDialogResult {
  constructor(
    public Changes: SmdDataRowModel[],
    public CurrentlySelected: string[],
    public OriginalSelected: string[],
  ) {}
}
